import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavigationActivityRouteData, NavigationActivityHandler } from './handlers/navigation-activity-handler';
import { ActivityLogger } from '../activity-logger';
import { ActivityData } from '../activity-data';

@Injectable()
export class NavigationActivityResolver implements Resolve<ActivityData> {
    constructor(private readonly activityLogger: ActivityLogger) {}

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const dataKey: keyof NavigationActivityRouteData = 'navigationActivityHandler';
        const handler: NavigationActivityHandler = route.data[dataKey];

        if (!handler) {
            throw new Error('Use navigationActivityHandler for route');
        }

        const activitySession = this.activityLogger.activitySession;
        const data = handler({ route, state, activitySession });

        return data;
    }
}

export interface NavigationActivityResolverData {
    activity: new (...args: any[]) => NavigationActivityResolver;
}

export const navigationActivity: NavigationActivityResolverData = {
    activity: NavigationActivityResolver
};